import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })

export class ServerRoutes {
	constructor(
		private router: Router
	) {}

	readonly server = "https://server.unolife.com.br";
	// readonly server = "http://localhost:3000";

	public requisicaoHTTP = (chamadaHTTP) => {
		return new Observable((observer) => {
			chamadaHTTP.subscribe(
				(res) => {
					observer.next(res);
				},
				(err) => {
					if (err.status == 422) {
						localStorage.clear();
						this.router.navigate([""]);
					} else {
						observer.error(err);
					}
				}
			);
		});
	};

	readonly address = this.server + "/v1/client/profissional/";
	readonly addressV2 = this.server + "/v2/api/professional/";
	readonly horaServidor = this.server + "/horaServidor";

	// auth
	readonly newUser = this.address + "auth/new";
	readonly login = this.addressV2 + "login";
	readonly uploadPerfilProfissional = this.address + "auth/upload/perfilProfissional";
	readonly uploadDocumento = this.address + "auth/upload/documento";
	readonly uploadCRP = this.address + "auth/upload/crp";

	// senha
	readonly enviarCodigoSenha = this.address + "enviarCodigoSenha";
	readonly atualizarSenha = this.address + "atualizarSenha";

	// perfil
	readonly getPerfil = (id) => this.address + "perfil/" + id;
	readonly getPerfilHasAgenda = (id) => this.address + "getPerfilHasAgenda/" + id;
	readonly editPerfil = this.address + "perfil/edit";
	readonly editPerfilDados = this.address + "perfil/edit-dados"
	readonly editSenhaDados = this.address + "perfil/edit-password"
	readonly editPerfilEndereco = this.address + "perfil/edit-endereco"
	readonly setBancario = this.address + "perfil/bancario";
	readonly updateBancario = this.address + "perfil/bancario-update";
	readonly uploadImage = this.address + "perfil/image";

	// agenda
	readonly postAgenda = this.address + "agenda";
	readonly getAgenda = this.address + "agenda";

	// atendimento
	readonly getMeusAtendimentos = (offset, limite, status) => this.address + "meusAtendimentos/" + offset + "/" + limite + "/" + status;
	readonly getAtendimentosWithoutBloqued = (offset, limite, status) => this.address + "meusAtendimentosNoBlock/" + offset + "/" + limite + "/" + status;
	readonly blockFreeHour = this.address + "blockFreeHour";
	readonly unblockFreeHour = this.address + "unblockFreeHour";
	readonly removeFreeHour = this.address + "removeFreeHour";
	readonly blockAllDay = this.address + "blockAllDay";
	readonly addNewHour = this.address + "addNewHour";
	readonly getVideocall = (codigo) => this.address + "videocall/" + codigo;
	readonly postComentario = (id) => this.address + "adicionarComentarioAtendimento/" + id + "/comentario";
	readonly getAtendimentosCliente = (userId, offset, limite) => this.address + "getAtendimentosCliente/" + userId + "/" + offset + "/" + limite;
	readonly recusarAtendimento = (atendimentoId) => this.address + "recusarAtendimento/" + atendimentoId;

	// financeiro
	readonly getFinanceiroTotais = (profissionalId) => this.address + "financeiroTotais/" + profissionalId;
	readonly getFinanceiro = (profissionalId) => this.address + "financeiro/" + profissionalId;

	// lgpd
	readonly setLgpd = (id) => this.address + "lgpd-confirm-professional/" + id;
	readonly getLgpd = (id) => this.address + "lgpd-verify-professional/" + id;

	//Plans
	readonly getUserPlans = (userId) => this.addressV2 + 'get-professional-plans/' + userId
	readonly getTypePlans = () => this.addressV2 + 'get-all-plans'
	readonly getPlanByTypeId = (typeId) => this.addressV2 + 'get-plan-by-type-id/' + typeId
	readonly getBoletoUrl = (transactionPagarmeId) => this.addressV2 + 'get-boleto-url/' + transactionPagarmeId
	readonly getPaymentPlan = (professionalPlanId) => this.addressV2 + 'get-professional-plan-payment/' + professionalPlanId
	readonly newPlan = this.addressV2 + 'new-plan'
	readonly newPlanRecurrent = this.addressV2 + 'new-plan-recurrent'

	// cash back
	readonly getPsiCahsBack = (profissionalId) => `${this.address}get-cash-back-psi/${profissionalId}`;
}
